module.exports = __webpack_public_path__ + "static/media/20180808_202513.7b5607f1.jpg";